// 🔧 /pages/public/email_action.js
// ✅ Purpose: Handle all Firebase email action links in one place
// ✅ Features:
// - Detects Firebase mode (verifyEmail, resetPassword, etc.)
// - Validates required oobCode param
// - Redirects user to the correct handler page
// - Safe from React Strict Mode double-execution

import React, { useEffect, useRef } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { logger } from "../../utils/logger";
import FullPageSpinner from "../../components/FullPageSpinner";

const EmailAction = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const hasRun = useRef(false); // 🧠 block double-run in Strict Mode

  useEffect(() => {
    if (hasRun.current) return;
    hasRun.current = true;

    const mode = searchParams.get("mode");
    const oobCode = searchParams.get("oobCode");

    if (!mode || !oobCode) {
      logger.warn("❌ Missing mode or oobCode in email action link", { mode });

      navigate("/login?msg=invalidLink", {
        replace: true,
      });

      return;
    }

    logger.log("📨 Email action detected:", {
      mode,
    });

    // 🧭 Redirect to appropriate page
    switch (mode) {
      case "verifyEmail":
      navigate(`/verify_email?${searchParams.toString()}`, {
        replace: true,
      });
      break;
      case "resetPassword":

      navigate(`/reset?${searchParams.toString()}`, {
        replace: true,
      });

      break;
      case "recoverEmail":

      navigate(`/recover_email?${searchParams.toString()}`, {
        replace: true,
      });

      break;
      default:
        logger.warn("⚠️ Unknown Firebase mode:", { mode });

        navigate("/login?msg=unsupportedAction", {
          replace: true,
        });

      }
  }, [navigate, searchParams]);

  return (
    <FullPageSpinner message="Processing email action..." />
  );

};

export default EmailAction;
